import TextArea from "antd/es/input/TextArea";
import { IoCloseSharp } from "react-icons/io5";
import { useHistory } from "react-router-dom";
import { Card, Col, Label, Modal, ModalBody, Row } from "reactstrap";
import { stringifySpecs } from "../../firebase/utility";
import FormInput from "../formInput/FormInput";

const ProductDetailsModal = ({ modal, toggle, newItem }) => {
    const history = useHistory();
    return (
        <Modal isOpen={modal} toggle={toggle} centered size="xl">
            <ModalBody className="p-4">
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <h4 className="primary-color">Line Item Details </h4>
                    <IoCloseSharp size={"30"} onClick={toggle} />
                </div>

                <Row className="mb-2">
                    <Col md={3}>
                        <Card className="p-3  h-100">
                            <h5 className="primary-color mb-2 border-bottom pb-2">Item Identifiers</h5>
                            <FormInput
                                readOnly={true}
                                type={"text"}
                                label={"SKU"}
                                size={'large'}
                                placeholder={"text"}
                                value={newItem?.sku ?? "N/A"}
                            />
                            <FormInput
                                readOnly={true}
                                type={"text"}
                                size={'large'}
                                label={"Vendor Part"}
                                placeholder={"Number"}
                                value={newItem?.vendor_part ?? "N/A"}
                            />
                            <FormInput
                                readOnly={true}
                                type={"text"}
                                size={'large'}
                                label={"MFG Part"}
                                placeholder={"select"}
                                value={newItem?.item_mfg_part ?? "N/A"}
                            />
                            <FormInput
                                readOnly={true}
                                type={"text"}
                                label={"UPC"}
                                size={'large'}
                                placeholder={"select"}
                                value={newItem?.item_upc ?? "N/A"}
                            />
                            <FormInput
                                readOnly={true}
                                type={"url"}
                                label={"Image Url"}
                                size={'large'}
                                placeholder={"Image URL"}
                                value={newItem?.imageUrl ?? "N/A"}
                            />
                        </Card>
                    </Col>
                    <Col md={3}>
                        <Card className="p-3 h-100">
                            <h5 className="primary-color mb-2 border-bottom pb-2"> Manufacturer & Category</h5>
                            <Label className="fw-bold fs-12 mb-1">MFG Name</Label>
                            <div
                                className="form-control border ps-2 bg-light text-primary pointer text-decoration-underline mb-3"
                                style={{ fontSize: '14px', display: 'flex', alignItems: 'center', height: '35px' }}
                                onClick={() => {
                                    localStorage.setItem('productSearch', newItem?.mfg_name || "");
                                    localStorage.setItem('productPage', 1);
                                    history.push('/admin/products');
                                    toggle();
                                }}
                            >
                                {newItem?.mfg_name ?? "N/A"}
                            </div>
                            <FormInput
                                readOnly={true}
                                type={"text"}
                                label={"Group"}
                                size={'large'}
                                placeholder={"select"}
                                value={newItem?.mfg_group ?? "N/A"}
                            />
                            <FormInput
                                readOnly={true}
                                type={"text"}
                                label={"Com.Group"}
                                size={'large'}
                                placeholder={"select"}
                                value={newItem?.mfg_com_group ?? "N/A"}
                            />
                            <FormInput
                                readOnly={true}
                                type={"text"}
                                label={"Category"}
                                size={'large'}
                                placeholder={"select"}
                                value={newItem?.mfg_category ?? "N/A"}
                            />
                            <FormInput
                                readOnly={true}
                                type={"text"}
                                label={"Condition New"}
                                size={'large'}
                                placeholder={"select"}
                                value={newItem?.mfg_condition ?? "N/A"}
                            />
                        </Card>
                    </Col>
                    <Col md={3}>
                        <Card className="p-3 h-100">
                            <h5 className="primary-color mb-2 border-bottom pb-2"> Dimensions</h5>

                            <FormInput
                                readOnly={true}
                                type={"text"}
                                label={"Length(IN)"}
                                size={'large'}
                                placeholder={"00"}
                                value={newItem?.length ?? "N/A"}
                            />

                            <FormInput
                                readOnly={true}
                                type={"text"}
                                label={"Height(IN)"}
                                size={'large'}
                                placeholder={"00"}
                                value={newItem?.height ?? "N/A"}
                            />

                            <FormInput
                                readOnly={true}
                                type={"text"}
                                label={"Width(IN)"}
                                placeholder={"00"}
                                size={'large'}
                                value={newItem?.width ?? "N/A"}
                            />

                            <FormInput
                                readOnly={true}
                                type={"text"}
                                label={"Weight(LBS)"}
                                placeholder={"00"}
                                size={'large'}
                                value={newItem?.weight ?? "N/A"}
                            />
                        </Card>
                    </Col>
                    <Col md={3}>
                        <Card className="p-3 h-100">
                            <h5 className="primary-color mb-2 border-bottom pb-2"> Stock</h5>

                            <FormInput
                                readOnly={true}
                                type={"text"}
                                label={"Quantity"}
                                placeholder={"00"}
                                size={'large'}
                                value={newItem?.stc_quantity ?? "N/A"}
                            />

                            <FormInput
                                readOnly={true}
                                type={"text"}
                                label={"Shelf / Placement"}
                                placeholder={"N/A"}
                                size={'large'}
                                value={newItem?.shelf_location || "N/A"}
                            />

                            <FormInput
                                readOnly={true}
                                type={"text"}
                                label={"Markup"}
                                placeholder={"00"}
                                size={'large'}
                                value={newItem?.stc_markup ?? "N/A"}
                            />

                            <FormInput
                                readOnly={true}
                                type={"text"}
                                label={"Map"}
                                size={'large'}
                                placeholder={"00"}
                                value={newItem?.stc_map ?? "N/A"}
                            />

                            <FormInput
                                readOnly={true}
                                type={"text"}
                                label={"Cost"}
                                size={'large'}
                                placeholder={"00"}
                                value={newItem?.stc_cost ?? "N/A"}
                            />

                            <FormInput
                                readOnly={true}
                                type={"text"}
                                size={'large'}
                                label={"Price"}
                                placeholder={"00"}
                                value={newItem?.price ?? "N/A"}
                            />

                            <FormInput
                                readOnly={true}
                                type={"text"}
                                label={"MSRP"}
                                size={'large'}
                                placeholder={"00"}
                                value={newItem?.stc_MSRP ?? "N/A"}
                            />
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <h4 className="primary-color mb-2 border-bottom pb-2"> Item Description</h4>
                    <Col md={4}>
                        <Label className="fw-bold">Title</Label>
                        <TextArea
                            type={"textarea"}
                            label={"Title"}
                            size={'large'}
                            placeholder={"Hello is this lirem title"}
                            value={newItem?.name ?? "N/A"}
                        />
                    </Col>
                    <Col md={4}>
                        <Label className="fw-bold">Description</Label>
                        <TextArea
                            type={"textarea"}
                            label={"Description"}
                            size={'large'}
                            placeholder={"Hello is this lirem title"}
                            value={newItem?.description ?? "N/A"}
                        />
                    </Col>
                    <Col md={4}>
                        <Label className="fw-bold">Specification</Label>
                        <TextArea
                            type={"Specification"}
                            size={'large'}
                            label={"Title"}
                            placeholder={"Hello is this lirem title"}
                            value={(newItem?.item_specification && typeof newItem.item_specification === 'object')
                                ? stringifySpecs(newItem.item_specification)
                                : (newItem?.item_specification ?? "N/A")}
                        />
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col md={12}>
                        <Label className="fw-bold">Long Description (Overview)</Label>
                        <TextArea
                            readOnly={true}
                            type={"textarea"}
                            label={"Long Description (Overview)"}
                            size={'large'}
                            rows={4}
                            value={newItem?.long_description ?? "N/A"}
                        />
                    </Col>
                </Row>
                <Row>
                    <h4 className="primary-color mb-2 border-bottom pb-2"> Settings</h4>
                    <Col md={3}>
                        <FormInput
                            readOnly={true}
                            type={"text"}
                            size={'large'}
                            label={"Display"}
                            placeholder={"select"}
                            value={newItem?.display}
                        />
                    </Col>
                    <Col md={3}>
                        <FormInput
                            readOnly={true}
                            type={"text"}
                            size={'large'}
                            label={"Feed"}
                            placeholder={"select"}
                            value={newItem?.feed}
                        />
                    </Col>
                    <Col md={3}>
                        <FormInput
                            readOnly={true}
                            type={"text"}
                            label={"Reset Quantity"}
                            size={'large'}
                            placeholder={"select"}
                            value={newItem?.reset_qty}
                        />
                    </Col>
                    <Col md={3}>
                        <FormInput
                            readOnly={true}
                            type={"text"}
                            label={"Facebook Ignore"}
                            size={'large'}
                            placeholder={"select"}
                            value={newItem?.facebook_ignore}
                        />
                    </Col>
                    <Col md={3}>
                        <FormInput
                            readOnly={true}
                            type={"text"}
                            label={"Update Price from DNH"}
                            size={'large'}
                            value={newItem?.updatePriceFromDnh ? "Enabled" : "Disabled"}
                        />
                    </Col>
                </Row>
            </ModalBody>
        </Modal>
    );
};

export default ProductDetailsModal;
